module.exports = __webpack_public_path__ + "img/upairy-compare-card.37f4de47.png";